import { forceCloseSxS, tryCloseSxS, tryExitSxSEditMode } from '../actions/publicLazyActions';
import { EditMode } from '../store/schema/SxSEditState';
import SxSStore from '../store/schema/SxSStore';
import sxsStore from '../store/Store';
import { EnteredEditModeEvent, ExitedEditModeEvent } from '../utils/eventNames';
import { orchestrator } from 'satcheljs';

async function tryCloseSxSOrchestrator(sxsStore: SxSStore, closingSource: string) {
    if (!sxsStore.viewState.previewPane) {
        return;
    }

    if (sxsStore.editState.mode === EditMode.View) {
        forceCloseSxS(closingSource);
    } else if (sxsStore.editState.mode === EditMode.EnteringEdit) {
        // wait for EnteredEditModeEvent and try again
        sxsStore.eventManager.once(EnteredEditModeEvent, async () => {
            await tryCloseSxSOrchestrator(sxsStore, closingSource);
        });
    } else {
        // Edit or Saving
        if (sxsStore.editState.mode === EditMode.Edit) {
            tryExitSxSEditMode();
        }

        // wait for ExitedEditModeEvent
        // try again if it exited edit mode successfully
        // otherwise force close SxS
        sxsStore.eventManager.once(ExitedEditModeEvent, async success => {
            if (success) {
                await tryCloseSxSOrchestrator(sxsStore, closingSource);
            } else {
                forceCloseSxS(closingSource);
            }
        });
    }
}

orchestrator(tryCloseSxS, async actionMessage => {
    const { closingSource } = actionMessage;
    await tryCloseSxSOrchestrator(sxsStore, closingSource);
});

// export for unit tests
export { tryCloseSxSOrchestrator };
